import { useLocation } from 'react-router-dom';
import cn from '../../../utils/cn';
import { GetDate } from '../../../utils/Show';

function TopLeftCol({ info }) {
    const {
        timeIssue,
        customInvoiceNo,
        quotationNo,
        isQuotation,
        organization: siteName,
        authorizedTime,
        title: invTxt
    } = info?.invoice || {};
    const {
        organization: asAgency,
        address,
        city,
        countryTitle,
        zip,
        state: addressState,
        phone
    } = info?.billingAddress || {};

    const { state } = useLocation();

    return (
        <div className="w-[calc(100%_-_287px)]">
            <div className="mb-5">
                <h2
                    className={cn('text-3xl leading-[normal] text-invoice-primary font-bold', {
                        // 'text-4xl': isQuotation
                    })}
                >
                    <span> {state?.title || invTxt}</span>
                </h2>
                <p className="text-xs2 leading-[normal] text-invoice-primary">
                    <span>
                        {isQuotation
                            ? `Quotation No : ${quotationNo || 'N/A'}`
                            : `Invoice No : ${customInvoiceNo || 'N/A'}`}
                    </span>
                    {/* <span>Invoice No : {customInvoiceNo || id}</span> */}
                </p>
                <div className="text-xs2 leading-[normal] font-medium text-invoice-primary mt-px">
                    <span> Date: {GetDate(authorizedTime === 0 ? timeIssue : authorizedTime)}</span>
                </div>
            </div>

            <div className="mt-[26px]">
                <p className="text-sm2 font-medium leading-[normal] text-invoice-primary">
                    <span>{asAgency}</span>
                </p>
                <p className="text-xs2 font-normal leading-[normal] text-invoice-secondary mt-1">
                    <span>
                        {[address, city, addressState, zip, countryTitle]
                            .filter((d) => !!d)
                            .join(', ') || '--------------'}
                    </span>
                </p>
                <p className="text-xs2 font-normal leading-[normal] text-invoice-secondary">
                    <span>Tel:&nbsp;{phone || '-----'}</span>
                </p>
                <p className="text-xs2 font-medium leading-[normal] text-invoice-primary mt-2">
                    Site:&nbsp;
                    <span> {siteName}</span>
                </p>
            </div>
        </div>
    );
}

export default TopLeftCol;
